var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FilterBase',{attrs:{"label":"Content Type"}},[_c('ValueSelect',{attrs:{"value":_vm.contentType,"options":_vm.contentTypes,"show-clear-button":"","placeholder":"Select a content type","label":"Content Type","hide-messages":true,"announced-field-cleared":false},on:{"value-selected":_vm.contentTypeSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }